import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as providersIt } from "./i18n/providers.lang-it";
import providersSettingsLinks from "./providers.settings-list";
import { RouterModule } from "@angular/router";
import providersRoutes from "./providers.routes";
import providersMenu from "./providers.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { ProvidersListComponent } from "./pages/providers-list/providers-list.component";
import { ProvidersCreateComponent } from './pages/providers-create/providers-create.component';
import { ProvidersEditComponent } from './pages/providers-edit/providers-edit.component';
import { ProvidersDetailComponent } from './pages/providers-detail/providers-detail.component';

@NgModule({
  declarations: [ProvidersListComponent, ProvidersCreateComponent, ProvidersEditComponent, ProvidersDetailComponent],
  imports: [RouterModule.forChild(providersRoutes), CommonModule, NgSelectModule, CoreCommonModule, ContentHeaderModule, TranslateModule, ExtendedModule, Ng2FlatpickrModule, NgxDatatableModule, NgbTooltipModule],
})
export class ProvidersModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("providers", providersIt, providersMenu, providersSettingsLinks);
  }
}
